import { clearRouteAction, setRouteAction } from './Actions'

/**
 * Set State Route
 * This will be read by VNRoutes component and redirect the app
 *
 * @param {String} route
 * @param {?Object} params
 * @returns
 */
export function setRoute(route, params = null) {
  return (dispatch) => {
    dispatch(setRouteAction(route, params))
  }
}

/**
 * Clear State Route
 *
 * @returns
 */
export function clearRoute() {
  return (dispatch) => {
    dispatch(clearRouteAction())
  }
}
